// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file message.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file message.proto.
 */
export const file_message: GenFile = /*@__PURE__*/
  fileDesc("Cg1tZXNzYWdlLnByb3RvEgtncnBjLmFwaS52MSLPAQoHTWVzc2FnZRIWCg5yZXNlcnZhdGlvbl9pZBgBIAEoAxI2CgxtZXNzYWdlX3R5cGUYAiABKA4yIC5ncnBjLmFwaS52MS5NZXNzYWdlLk1lc3NhZ2VUeXBlEg8KB3N1YmplY3QYAyABKAkSDAoEYm9keRgEIAEoCRIQCghzZW5kX2JjYxgFIAEoCBITCgtmZWVkYmFja19pZBgGIAEoAyIuCgtNZXNzYWdlVHlwZRIICgROT05FEAASDAoIU0VOREdSSUQQARIHCgNTTVMQA0IGWgQuO3BiYgZwcm90bzM");

/**
 * Message
 *
 * @generated from message grpc.api.v1.Message
 */
export type Message = Message$1<"grpc.api.v1.Message"> & {
  /**
   * @generated from field: int64 reservation_id = 1;
   */
  reservationId: bigint;

  /**
   * @generated from field: grpc.api.v1.Message.MessageType message_type = 2;
   */
  messageType: Message_MessageType;

  /**
   * @generated from field: string subject = 3;
   */
  subject: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: bool send_bcc = 5;
   */
  sendBcc: boolean;

  /**
   * @generated from field: int64 feedback_id = 6;
   */
  feedbackId: bigint;
};

/**
 * Describes the message grpc.api.v1.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_message, 0);

/**
 * @generated from enum grpc.api.v1.Message.MessageType
 */
export enum Message_MessageType {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: SENDGRID = 1;
   */
  SENDGRID = 1,

  /**
   * @generated from enum value: SMS = 3;
   */
  SMS = 3,
}

/**
 * Describes the enum grpc.api.v1.Message.MessageType.
 */
export const Message_MessageTypeSchema: GenEnum<Message_MessageType> = /*@__PURE__*/
  enumDesc(file_message, 0, 0);

